import * as React from "react";
//import styles from './Login.css';
import { v4 } from "uuid";

import { withStyles, WithStyles, createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';

import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
//import '../../resources/img/bg1.jpg';
import { ThemeProvider } from '@material-ui/core/styles';

import { createMuiTheme } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';
import TextField from '@material-ui/core/TextField';

import ExamServer, { Execution } from '../server/ExamServer'

import Activation from './Activation'
import CreateExam from "./CreateExam";
import Hidden from '@material-ui/core/Hidden';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import Chip from '@material-ui/core/Chip';
import Divider from '@material-ui/core/Divider';
import Fab from '@material-ui/core/Fab';
import CheckIcon from '@material-ui/icons/Check';
import Link from '@material-ui/core/Link';




const theme = createMuiTheme({
    // palette: {
    //     primary: {
    //         main: '#44423e'
    //     },
    //     secondary: {
    //         main: '#FDC400',
    //         contrastText: '#fff'
    //     }
    // }

});


const styles = ((theme: Theme) => createStyles({
    root: {
        padding: theme.spacing(2)
    }
}))



export interface LoginProps extends WithStyles<typeof styles> {
    enterRoom: boolean
    onActivate?: () => void
    onStart?: (exec: Execution) => void
    openLegalNotice: () => void
    openPrivacyPolicy: () => void
    openAdministrator: () => void
}

export interface LoginState {
    searchText: string,
    loading: boolean,
}


class Login extends React.Component<LoginProps, LoginState> {


    constructor(props: LoginProps) {
        super(props);
        this.state = {
            searchText: "",
            loading: false,
        };

    }

    activationCodeTextChanged = (event: React.ChangeEvent<HTMLInputElement>) => {

        this.setState({ searchText: event.target.value });
    }
    activationCodeTextKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            //this.handleSearch()
        }
    }

    activate = () => {
        this.props.onActivate && this.props.onActivate()
    }

    start = (exec: Execution) => {
        this.props.onStart && this.props.onStart(exec)
    }

    render() {

        const { classes } = this.props;

        return (
            <React.Fragment>
                <Hidden xsDown>
                    <Grid container
                        justify="center"
                        alignItems="center"
                        style={{
                            height: "calc(100vh - 200px)"
                        }}
                    >
                        <Grid item md={8} lg={6} xl={6}>
                            <Typography variant="h4" color="textSecondary" component="h4" align="center">
                                Welcome to
                            </Typography>
                            <Typography variant="h2" color="textPrimary" component="h3" align="center">
                                English Beyond Borders
                            </Typography>
                            <Typography variant="h3" color="textPrimary" component="h3" align="center">
                                Placement Test
                            </Typography>

                            <Paper style={{ marginTop: theme.spacing(5), padding: theme.spacing(3) }}>
                                {this.props.enterRoom ? (
                                    <Activation onActivate={this.activate} />
                                ) : (
                                        <CreateExam onCreated={this.start} />
                                    )}


                            </Paper>


                        </Grid>



                    </Grid>
                </Hidden>
                <Hidden smUp>
                    <div style={{ paddingTop: theme.spacing(5), paddingBottom: theme.spacing(5) }}>
                        <Typography variant="h4" color="textSecondary" component="h4" align="center">
                            Welcome to
                            </Typography>
                        <Typography variant="h2" color="textPrimary" component="h3" align="center">
                            English Beyond Borders
                            </Typography>
                        <Typography variant="h3" color="textPrimary" component="h3" align="center">
                            Placement Test
                            </Typography>
                    </div>

                    {this.props.enterRoom ? (
                        <Activation onActivate={this.activate} />
                    ) : (
                            <CreateExam onCreated={this.start} />
                        )}
                </Hidden>
                <div style={{ padding: theme.spacing(5)}}>
                    <Typography variant="body1" color="textSecondary" align="center">

                        <Link onClick={this.props.openLegalNotice} style={{cursor:"pointer"}}>
                            Impressum
                        </Link> | <Link onClick={this.props.openPrivacyPolicy} style={{cursor:"pointer"}}>
                            Datenschutzerklärung
                        </Link> | <Link onClick={this.props.openAdministrator} style={{cursor:"pointer"}}>
                            Administration
                    </Link>
                    </Typography>
                </div>
            </React.Fragment>


        )
    }
}

export default withStyles(styles)(Login);
